import { setHeaderHeight } from './_utils';

const trendsBanner = document.getElementById('banner-trends');

if (trendsBanner) {
    const getCookie = name => {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? match[2] : null;
    };

    const setCookie = (name, value, days) => {
        const expires = new Date();
        expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
    };

    if (getCookie('banner_trends_dismissed')) {
        trendsBanner.remove();
    } else {
        document.getElementById('banner-trends-close').addEventListener('click', () => {
            document.documentElement.classList.replace('banner-trends-active', 'banner-trends-dismissed');
            setCookie('banner_trends_dismissed', '1', 14);
            trendsBanner.remove();
            setHeaderHeight();

            const menu = document.querySelector('.menu');
            if (menu) menu.style.top = document.querySelector('header').offsetHeight + 'px';
        });
    }
}
